export const PLF_TYPE = {
    BEAUTYX: "BEAUTYX",
    MOMO: "MOMO",
    TIKI: "TIKI",
    MB: "MBBANK",
    ZALO: "ZALO",
    VIETTEL:"VIETTEL"
}